import React from 'react';
import { X, Sparkles } from 'lucide-react';

export default function AppliedFilterChip({ filter, onRemove }) {
  return (
    <span
      className="animate-chipSlideIn group inline-flex items-center gap-1.5 rounded-full bg-brand-50 dark:bg-brand-900/30 border border-brand-200 dark:border-brand-800 px-2.5 py-1 text-xs font-medium text-brand-700 dark:text-brand-300"
    >
      {filter.source === 'ai' && (
        <Sparkles className="w-3 h-3 text-brand-400 flex-shrink-0" />
      )}
      <span className="truncate max-w-[200px]">{filter.label}</span>
      <button
        type="button"
        onClick={() => onRemove(filter.id)}
        className="flex-shrink-0 rounded-full p-0.5 text-brand-400 hover:text-brand-700 dark:hover:text-brand-200 hover:bg-brand-100 dark:hover:bg-brand-900/60 transition-colors"
        aria-label="Remove filter"
      >
        <X className="w-3 h-3" />
      </button>
    </span>
  );
}
